import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { useState, useEffect } from "react";
import { Editor } from 'react-draft-wysiwyg';

export const Carta = () => {
    const [editorState, setEditorState] = useState(() => {
        const input = document.querySelector('[id$="hfContenidoCartaJSONTemp"]');

        if (input) {
            const value = input.value;

            if (value) {
                const rawContent = JSON.parse(value);
                const contentState = convertFromRaw(rawContent);
                return EditorState.createWithContent(contentState);
            }
            else {
                return EditorState.createEmpty();
            }
        } else {
            return EditorState.createEmpty();
        }
    });

    const [variables, setVariables] = useState([]);
    const [mostrarVariables, setMostrarVariables] = useState(false);
    const [variableCopiada, setVariableCopiada] = useState(null);

    useEffect(() => {
        const hfVariablesPropiedades = document.querySelector('[id$="hfVariablesPropiedades"]');

        if (hfVariablesPropiedades && hfVariablesPropiedades.value) {
            const variablesArray = hfVariablesPropiedades.value
                .split(',')
                .map(v => v.trim())
                .filter(v => v !== '');
            setVariables(variablesArray);
        }
    }, []);

    const onEditorStateChange = (editorState) => {
        setEditorState(editorState);
    };

    const obtenerContenidoJSON = () => {
        const contentState = editorState.getCurrentContent();
        const rawContent = convertToRaw(contentState);
        const jsonContent = JSON.stringify(rawContent);

        return jsonContent;
    };

    const handleGenerarDocumento = () => {
        const contentJSON = obtenerContenidoJSON();

        const inputTemp = document.querySelector('[id$="hfContenidoCartaJSONTemp"]');

        if (inputTemp) {
            inputTemp.value = contentJSON;
        }

        const contenidoJSONInput = document.getElementById("contenidoCartaJSON");

        if (contenidoJSONInput) {
            contenidoJSONInput.value = contentJSON;
        }

        const btnGuardarJSON = document.getElementById("btnGuardarContenidoJSON");
        if (btnGuardarJSON) {
            btnGuardarJSON.click();
        }
    };

    const handleCopiarVariable = async (variable) => {
        const textoACopiar = `{{${variable}}}`;

        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(textoACopiar);
            } else {
                const textarea = document.createElement('textarea');
                textarea.value = textoACopiar;
                textarea.style.position = 'fixed';
                textarea.style.opacity = '0';
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand('copy');
                document.body.removeChild(textarea);
            }

            setVariableCopiada(variable);

            setTimeout(() => {
                setVariableCopiada(null);
            }, 2000);

        } catch (error) {
            console.error('Error al copiar al portapapeles:', error);
        }
    };

    const handleInsertarVariable = (variable) => {
        const contentState = editorState.getCurrentContent();
        const selection = editorState.getSelection();
        
        const newContentState = contentState.createEntity(
            'IMMUTABLE',
            'MUTABLE',
            { variable }
        );
        
        const newEditorState = EditorState.set(editorState, {
            currentContent: newContentState
        });
        
        const currentContent = newEditorState.getCurrentContent();
        const currentSelection = newEditorState.getSelection();
        
        const textWithVariable = `{{${variable}}}`;
        const newContent = window.Modifier.insertText(
            currentContent,
            currentSelection,
            textWithVariable
        );
        
        const finalEditorState = EditorState.push(
            newEditorState,
            newContent,
            'insert-characters'
        );
        
        setEditorState(finalEditorState);
        setMostrarVariables(false);
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '1000%' }}>
            <div style={{
                padding: '10px',
                backgroundColor: '#f8f9fa',
                borderBottom: '1px solid #ddd',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                <label 
                    onClick={() => setMostrarVariables(!mostrarVariables)}
                    style={{
                        cursor: 'pointer',
                        color: '#4a90e2',
                        fontWeight: 'bold',
                        userSelect: 'none'
                    }}
                >
                    {mostrarVariables ? '▼' : '▶'} Variables Disponibles ({variables.length})
                </label>
            </div>

            {mostrarVariables && variables.length > 0 && (
                <div style={{
                    maxHeight: '200px',
                    overflowY: 'auto',
                    backgroundColor: '#ffffff',
                    border: '1px solid #ddd',
                    borderTop: 'none'
                }}>
                    <ul style={{
                        listStyle: 'none',
                        margin: 0,
                        padding: 0
                    }}>
                        {variables.map((variable, index) => (
                            <li
                                key={index}
                                onClick={() => handleCopiarVariable(variable)}
                                style={{
                                    padding: '8px 15px',
                                    cursor: 'pointer',
                                    borderBottom: '1px solid #f0f0f0',
                                    transition: 'background-color 0.2s',
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    backgroundColor: variableCopiada === variable ? '#e7f5e7' : '#ffffff'
                                }}
                                onMouseEnter={(e) => {
                                    if (variableCopiada !== variable) {
                                        e.currentTarget.style.backgroundColor = '#f0f0f0';
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (variableCopiada !== variable) {
                                        e.currentTarget.style.backgroundColor = '#ffffff';
                                    }
                                }}
                            >
                                <code style={{
                                    backgroundColor: variableCopiada === variable ? '#d4edda' : '#f5f5f5',
                                    padding: '2px 6px',
                                    borderRadius: '3px',
                                    fontFamily: 'monospace',
                                    fontSize: '12px',
                                    transition: 'background-color 0.3s'
                                }}>
                                    {`{{${variable}}}`}
                                </code>

                                {variableCopiada === variable && (
                                    <span style={{
                                        color: '#28a745',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '4px'
                                    }}>
                                        ✓ Copiado
                                    </span>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>
            )}

            <div style={{
                flex: '1',
                marginBottom: '10px',
                border: '1px solid #ddd',
                overflow: 'auto'
            }}>
                <Editor
                    spellCheck
                    toolbar={{
                        options: [
                            "inline",
                            "fontSize",
                            "fontFamily",
                            "list",
                            "history",
                            "textAlign"
                        ],
                        fontFamily: {
                            inDropdown: true,
                            options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana'],
                        },
                        textAlign: {
                            inDropdown: false,
                            className: undefined,
                            component: undefined,
                            dropdownClassName: undefined,
                            options: ['left', 'center', 'right', 'justify']
                        },
                    }}
                    localization={{ locale: "es" }}
                    editorState={editorState}
                    onEditorStateChange={onEditorStateChange}
                    editorStyle={{ paddingLeft: "10px", minHeight: "400px" }}
                    toolbarClassName="editor-toolbar"
                    wrapperClassName="wrapper-react-draft-comentario"
                    editorClassName="editor-content"
                />
            </div>

            <div style={{
                padding: '10px',
                borderTop: '1px solid #ddd'
            }}>
                <button
                    type="button"
                    onClick={handleGenerarDocumento}
                    style={{
                        backgroundColor: '#4a90e2',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                    }}
                >
                    Guardar
                </button>
            </div>
        </div>
    );
}